export default "__VITE_ASSET__Is2mJJgQ__"